module.exports = __webpack_public_path__ + "img/notification-clip-board.81f5e5e9.svg";